import { logOut } from "../../redux/Actions/LoginActions";
import { getUserStatus } from "../../redux/Actions/GetDocsActions";

export const mapDispatchToProps = (dispatch) => {
  return {
    logOut: (payload, history) => dispatch(logOut(payload, history)),
    getStatus: () => dispatch(getUserStatus()),
  };
};
